<template>
	<div class="apply-con" :style="applyConStyle">
		<!--页头-->
		<mobile-header></mobile-header>
		<!--内容页-->
		<mobile-main
		@go="goWhere"
		@filter="disPlayFilter"
		@update="updateDafaultData"
		@submit="updateSubmitInfo"
		:filterSelected="filterSelected"
		:isUpdateDefaultData="isUpdateDefaultData"
		:defaultStep="defaultStep"
		:defaulItemDetail="defaulItemDetail"
		:defaultSubmitInfo="defaultSubmitInfo"
		:applyMainStyle="applyMainStyle"></mobile-main>
		<!--页脚-->
		<mobile-footer :applyFooterStyle="applyFooterStyle"></mobile-footer>
		<!--按钮组-->
		<mobile-btns
		v-if="defaultStep==2||defaultStep==3"
		@go="goWhere"
		@update="initalizAll"
		:defaultSubmitInfo="defaultSubmitInfo"
		:defaulItemDetail="defaulItemDetail"
		:defaultStep="defaultStep"></mobile-btns>
		<!--筛选项-->
		<mobile-group
		:isFilterShow="isFilterShow"
		:filterSelected="filterSelected"
		@update="updateDafaultData"
		@select="addFilter"
		@filter="disPlayFilter"></mobile-group>
	</div>
</template>
<script>
    export default{
        components: {
            MobileHeader: () => import('@/components/mobile/zh-cn/header'),
            MobileFooter: () => import('@/components/mobile/zh-cn/footer'),
            MobileMain: () => import('@/components/mobile/zh-cn/apply/apply-main'),
            MobileBtns: () => import('@/components/mobile/zh-cn/apply/apply-btns'),
            MobileGroup: () => import('@/components/mobile/zh-cn/apply/apply-group')
        },
        data(){
            const _this = this;
            return {
                defaultStep: 1,
                isFilterShow: false,
                isUpdateDefaultData: false,
                filterSelected: {},
                defaulItemDetail: {},
                defaultSubmitInfo: {
                    itemName: '',
                    itemCountry: '',
                    itemCity: '',
                    itemPhone: '',
                    itemEmail: '',
                    itemFile: ''
                },
                applyMainStyle: {
                    Height: window.screen.availHeight,
                },
                applyConStyle: {
                    Height: window.screen.availHeight,
                },
                applyFooterStyle: {
                    marginBottom: '0rem'
                }
            };
        },
        methods: {
            goWhere(params){
                const _this = this;
                _this.defaultStep = params.stepId;
                _this.defaulItemDetail = params.data;
                _this.updateFooterStyle(params.stepId);
            },
            disPlayFilter(state){
                const _this = this;
                _this.isFilterShow = state;
            },
            addFilter(filterCondition){
                const _this = this;
                _this.filterSelected = filterCondition;
            },
            updateDafaultData(state){
                const _this = this;
                _this.isUpdateDefaultData = state;
                _this.isFilterShow = false;
            },
            updateSubmitInfo(attr){
                const _this = this;
                //console.log("#0[apply][updateSubmitInfo]", attr)
                if ($.isPlainObject(attr) && $.isEmptyObject(attr) === false) {
                    for (var itemName in attr) {
                        _this.defaultSubmitInfo[itemName] = attr[itemName];
                    }
                }
            },
            initalizAll(){
                const _this = this;
                Object.assign(_this.$data.defaulItemDetail, _this.$options.data().defaulItemDetail);
                Object.assign(_this.$data.defaultSubmitInfo, _this.$options.data().defaultSubmitInfo);
            },
            updateFooterStyle(stepId){
                const _this = this;
                if ([2, 3].indexOf(stepId) > -1) {
                    _this.applyFooterStyle = {
                        marginBottom: '6.125rem'
                    };
                } else {
                    _this.applyFooterStyle = {
                        marginBottom: '0rem'
                    };
                    Object.assign(_this.$data.applyFooterStyle, _this.$options.data().applyFooterStyle);
                }
            }
        },
        watch: {
            isFilterShow(bool){
                const _this = this;
                if (bool) {
                    document.body.style.overflow = 'hidden';
                } else {
                    _this.applyMainStyle.background = '#E1E1E1';
                    document.body.style.overflow = 'auto';
                }
            },
            defaultStep: 'updateFooterStyle'
        },
        mounted(){
            const _this = this;
            _this.applyMainStyle.background = [2, 3].indexOf(Number(_this.defaultStep)) === -1 ? '#FFFFFF' : '#E1E1E1';
            _this.updateFooterStyle(1);
            _this.$nextTick(() => {
                document.body.style.overflow = 'auto';
            });
            //console.log("#0[apply][defaultStep]", this.defaultStep)
        }
    }
</script>

<style scoped="">

	@import "../../../assets/mobile/css/apply.css";

</style>


// WEBPACK FOOTER //
// src/components/mobile/zh-cn/apply.vue